import React from "react";
import { useLocation } from "react-router-dom";

// Layout/UI
import { Box, Text } from "@metrea-ui/v2";

const Footer = () => {
	const year = new Date().getFullYear();
	const location = useLocation();
	const landingPage = location.pathname === "/" && !location.search.includes("getCode=true");

	const landingPageClassName = landingPage ? "landing-page" : "";

	return (
		<footer className={`footer ${landingPageClassName}`}>
			<div className="footer-wrapper">
				<div className="footer__end-wrapper">&nbsp;</div>
				<div className="footer__left-wrapper">
					<div className="footer__msi-logo">
						<a href="##">
							<img
								className="footer__logo"
								alt="MSI"
								data-src={landingPage ? "MSI-White.png" : "MSI-Blue.png"}
								src={landingPage ? "/MSI-White.png" : "/MSI-Blue.png"}
							/>
							<noscript>
								<img src="MSI-Blue.png" alt="MSI" />
							</noscript>
						</a>{" "}
					</div>
				</div>
				<div className="footer__right-wrapper">
					<div className={`footer__copyright ${landingPageClassName}`}>
						Copyright{" "}
						<Text as="span" fontSize="sm" color="gray.600" aria-label="Copyright">
							©
						</Text>{" "}
						{year}
					</div>
					<div className={`flex-padding`}>{" | "}</div>
					<div className={`footer__privacy ${landingPageClassName}`}>Privacy Policy</div>
				</div>
				<div className="footer__end-wrapper">&nbsp;</div>
			</div>
		</footer>
	);
};

export const PageFooter = () => {
	const year = new Date().getFullYear();

	return (
		<Box mt="auto">
			<Box
				style={{
					fontSize: "10px",
					fontWeight: 400,
					lineHeight: "14px",
					display: "flex",
					justifyContent: "start",
					marginTop: "30px",
				}}
			>
				<Text as="span" fontSize="sm" color="gray.600" aria-label="Copyright">
					Copyright © {year}
				</Text>

				{/* <div>&nbsp; | &nbsp;</div>
				<div>Privacy Policy</div> */}
			</Box>
		</Box>
	);
};

export default Footer;
